export default __webpack_public_path__ + "images/JAMAIR.82054de.png";